export default __webpack_public_path__ + "static/media/avatar_19.049f0391.png";